import { render, staticRenderFns } from "./dialogEditarProducto.vue?vue&type=template&id=fd1ae98e&"
import script from "./dialogEditarProducto.vue?vue&type=script&lang=js&"
export * from "./dialogEditarProducto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports